<template>
  <StatusDialog
    :visible.sync="dialogVisible"
    type="warning"
    :width="500"
    @close="onCancel"
  >
    <h3 class="status-dialog__title">删除确认</h3>
    <p class="status-dialog__desc">{{ message }}</p>
    <div class="status-dialog__footer">
      <button
        type="button"
        class="status-dialog__btn status-dialog__btn--primary"
        :disabled="loading"
        @click="onConfirm"
      >
        确定
      </button>
    </div>
  </StatusDialog>
</template>

<script>
export default {
  name: 'TitleDeleteConfirmDialog',

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },

  methods: {
    onCancel() {
      if (this.loading) return;
      this.$emit('cancel');
    },
    onConfirm() {
      if (this.loading) return;
      this.$emit('confirm');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/view/client/personal-center/panels/TitleManage/DeleteConfirmDialog.vue